import dayjs from "dayjs";

dayjs.locale("ja"); // グローバルで日本語を利用

/**
 *  開始日時と終了日時を受け取り、フォーマットされた日時を返す
 * @param startISO 開始日時
 * @param endISO 終了日時
 * @returns フォーマットされた日時
 * @example
 * formatDuration("2021-08-01T10:00:00.000Z", "2021-08-02T10:00:00.000Z") => "2021年8月1日（日）10:00 ～ 8月2日（月）10:00"
 */
export const formatDuration = (startISO: string, endISO: string) => {
  const start = dayjs(startISO);
  const end = dayjs(endISO);

  // 1日目は「年」も表示し、曜日は全角括弧で囲む
  const startStr = `${start.format("YYYY年M月D日")}（${start.format("ddd")}）${start.format("H:mm")}`;

  // 同じ年の場合、2日目は「年」を省略する例
  const endStr = `${end.format("M月D日")}（${end.format("ddd")}）${end.format("H:mm")}`;

  return `${startStr} ～ ${endStr}`;
};
